// extracted by mini-css-extract-plugin
module.exports = {"root":"ChampionshipList_root__ldPLK","loaderWrapper":"ChampionshipList_loaderWrapper__VO8fl","loaderContainer":"ChampionshipList_loaderContainer__I61NX"};